// extracted by mini-css-extract-plugin
export var rendezVousRecapContainer = "rendez-vous-part-7-module--rendez-vous-recap-container--2309c";
export var rendezVousTitle = "rendez-vous-part-7-module--rendez-vous-title--27d86";